import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { AP_AGING_DEFAULT_STATUSES, AP_AGING_ELIGIBLE_STATUSES } from "../constants"

import { ApAgingBucket } from "@/graphql/codegen/graphql"

// z.string().date() validates strict ISO-8601 calendar dates (rejects 2026-02-30, 2026-13-01, etc.).
const isoDateSchema = fallback(z.string().date().optional(), undefined)

const eligibleStatusSchema = z.enum(AP_AGING_ELIGIBLE_STATUSES, {
  message: "Status is not part of the AP Aging Report",
})

export const apAgingReportSearchParamsSchema = z.object({
  query: z.string().optional(),

  // AK-6964 AC2: Approved is the real default of `statuses`, so the chips and the drawer show it like any other filter.
  // An explicit empty array stays empty; only an absent or invalid value falls back to the default.
  statuses: fallback(z.array(eligibleStatusSchema).default(AP_AGING_DEFAULT_STATUSES), AP_AGING_DEFAULT_STATUSES),
  // AK-6964 AC9: No aging bucket selected means every bucket is included.
  agingBuckets: fallback(z.array(z.nativeEnum(ApAgingBucket)).optional(), undefined),
  dueDateFrom: isoDateSchema,
  dueDateTo: isoDateSchema,
})

export type ApAgingReportSearchParams = z.infer<typeof apAgingReportSearchParamsSchema>
